import {
  ITransaction,
  TransactionItem,
  groupTransactionsByDate,
} from '@/entities/transaction';

import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/ui';

import { TransactionsDetailsModal } from './details/details-modal';

interface GroupedTransactionsProps {
  transactions: ITransaction[];
}
export const GroupedTransactions = ({
  transactions,
}: GroupedTransactionsProps) => {
  const groupedTransactions = groupTransactionsByDate(transactions);
  return (
    <div className="px-3">
      {Object.entries(groupedTransactions).map(
        ([date, transactions], index) => (
          <Table key={date}>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[390px] py-6 text-[14px] leading-5">
                  {date}
                </TableHead>
                {index === 0 && (
                  <>
                    <TableHead className="py-6 text-[14px] leading-5">
                      Status
                    </TableHead>
                    <TableHead className="py-6 text-right text-[14px] leading-5">
                      Amount
                    </TableHead>
                  </>
                )}
              </TableRow>
            </TableHeader>
            <TableBody>
              {transactions.map((transaction) => (
                <TransactionsDetailsModal
                  transaction={transaction}
                  key={transaction.id}
                >
                  {(setIsDetailsOpen) => (
                    <TableRow
                      className="cursor-pointer"
                      onClick={setIsDetailsOpen}
                    >
                      <TransactionItem
                        transaction={transaction}
                        variant="group"
                      />
                    </TableRow>
                  )}
                </TransactionsDetailsModal>
              ))}
            </TableBody>
          </Table>
        ),
      )}
    </div>
  );
};
